export default {
  init() {
    // JavaScript to be fired on all pages

    // add active class to form on trigger
    $(function() {
      $('.contact-form-trigger').click(function() {
        $('.contact-wrapper').addClass('active');
        $('body').addClass('form-active');
      });
    });

    //close form
    $(function() {
      $('.form-close').click(function() {
        $('.contact-wrapper').removeClass('active');
        $('.inner-wrapper .nav-primary').removeClass('active');
        $('.mobile-menu-trigger .open-menu').addClass('active');
        $('.mobile-menu-trigger .close-menu').removeClass('active');
        $('body').removeClass('form-active');
      });
    });

    // open mobile menu
    $(function() {
      $('.mobile-menu-trigger').click(function() {
        $('.inner-wrapper .nav-primary').toggleClass('active');
        $('.mobile-menu-trigger .open-menu').toggleClass('active');
        $('.mobile-menu-trigger .close-menu').toggleClass('active');
        $('body').toggleClass('form-active');
      });
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



//////////////////
// WEBPACK FOOTER
// ./scripts/routes/common.js
// module id = 17
// module chunks = 0